// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { SpotlightPulse, SpotlightTransition } from '@atlaskit/onboarding';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren, useCallback, useState } from 'react';

import { IntroductionStep } from './introduction-step';
import { ParentStep } from './parent-step';
import type { SpotlightTourStep } from './types';

const STEPS: SpotlightTourStep[] = [IntroductionStep, ParentStep];

export const FilterRefinementSpotlightTour = ({ children }: PropsWithChildren) => {
	const [step, setStep] = useState<number | null>(0);

	const { messageInstanceClicked } = useMessageInstanceEvent();

	const onDismiss = useCallback(() => {
		setStep(null);

		// Dismisses the message so it is not displayed again to the user
		// @see https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/system-filters/#dismissal-check-filter
		void messageInstanceClicked({
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {
				step,
			},
			clickedElement: {
				buttonType: 'secondary',
				clickedElement: 'button',
				clickIdentifier: 'dismiss',
			},
			messageEventType: 'clicked',
		});
	}, [messageInstanceClicked, step]);

	const onNext = useCallback(() => {
		if (step !== null && step < STEPS.length - 1) {
			setStep(step + 1);
		} else {
			onDismiss();
		}
	}, [onDismiss, step]);

	const StepComponent = step !== null ? STEPS[step] : null;

	return (
		<>
			<SpotlightPulse radius={3} pulse={step === 0}>
				{children}
			</SpotlightPulse>
			{StepComponent && (
				<SpotlightTransition>
					<StepComponent onDismiss={onDismiss} onNext={onNext} />
				</SpotlightTransition>
			)}
		</>
	);
};
